module.exports = __webpack_public_path__ + "img/verify-by-email.c464abe3.svg";